import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as authService from "../../../../services/authService";
import { RouteConstants } from "../../../../constants/ApplicationConstants/RouteConstants";

import { clearReduxStoreAction, updateLocationList, updateMasterFilters } from "../../../../appRedux/reducers/Common";
import { CustomNotification } from "../../../../util/CustomNotification";
import * as commonAPI from "../../../../services/commonServices";
import LocalStorageUtil from "../../../../util/LocalStorageUtil";
import { LocalStorageConstants } from "../../../../constants/ApplicationConstants/LocalStorageConstants";

import type { RootState } from "../../../../appRedux/store";
import type { UserInterface } from "../../../../shared/interface/auth/User.interface";
import { MasterFiltersConstant } from "../../../../constants/ApplicationConstants/MasterConstant";

export const useUserProfile = () => {
  /* CONSTANTS */
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userData = LocalStorageUtil.localStorageGetItem(LocalStorageConstants.USER_DATA) as UserInterface;

  /* STATE */
  const [open, setOpen] = useState<boolean>(false);

  const { customerList, locationList, masterFilters } = useSelector(({ common }: RootState) => common);

  /* HANDLERS */
  const handleOpenChange = (newOpen: boolean) => setOpen(newOpen);
  const hide = () => setOpen(false);

  const handleAbout = () => hide();
  const handleMyAccount = () => hide();
  const handleLogOut = async () => {
    try {
      hide();
      const response = await authService.signOutAPI();
      CustomNotification.showSuccessMessage(response.message);
    } catch (error) {
      // CustomNotification.showErrorMessage(error);
    } finally {
      localStorage.clear();
      dispatch(clearReduxStoreAction());
      navigate(RouteConstants.ROOT_PAGE);
    }
  };

  const handleChangeCustomer = (id: number | null) => {
    const dataObj = {
      [MasterFiltersConstant.CUSTOMER_ID]: id,
      [MasterFiltersConstant.LOCATION_ID]: null,
      [MasterFiltersConstant.CLIENT_ID]: null,
      [MasterFiltersConstant.KEY_FOB_ID]: null
    };

    LocalStorageUtil.localStorageUpdateData(LocalStorageConstants.MASTER_FILTERS, dataObj);
    dispatch(updateLocationList([]));
    dispatch(updateMasterFilters(dataObj));
  };

  const handleChangeLocation = (id: number | null) => {
    const dataObj = {
      [MasterFiltersConstant.CUSTOMER_ID]: masterFilters?.customerId,
      [MasterFiltersConstant.LOCATION_ID]: id,
      [MasterFiltersConstant.CLIENT_ID]: null,
      [MasterFiltersConstant.KEY_FOB_ID]: null
    };
    LocalStorageUtil.localStorageUpdateData(LocalStorageConstants.MASTER_FILTERS, dataObj);
    dispatch(updateMasterFilters(dataObj));
  };

  /* EFFECT */

  /* fetchLocationList  */
  useEffect(() => {
    const fetchLocationList = async (customerId: number) => {
      try {
        const response = await commonAPI.getLocationListByCustomerId(customerId);
        dispatch(updateLocationList(response?.data));
      } catch (error) {
        CustomNotification.showErrorMessage(error);
      }
    };
    if (masterFilters?.customerId) fetchLocationList(masterFilters?.customerId);
  }, [masterFilters?.customerId]);

  return { open, userData, customerList, locationList, handleOpenChange, handleAbout, handleMyAccount, handleLogOut, customerId: masterFilters?.customerId, locationId: masterFilters?.locationId, handleChangeCustomer, handleChangeLocation };
};
